import { Meal, Product, ProductPrice } from './product';
import { WeekDay } from './menu';
import { DeliveryLocation } from './location';
import { PaymentMethod } from 'src/app/types/payment';

export interface Order {
  id: number;
  type: OrderType;
  items: OrderItem[];
  paymentStatus: OrderPaymentStatus;
  delivered: boolean;
  refundRequested: boolean;
  createdAt: number;
  deliveredAt: number;
  location: DeliveryLocation;
  prices: ProductPrice;
  paymentType: PaymentMethod;
}

export enum OrderType {
  DELIVERY = 1,
  IN_STORE = 2,
}

export enum OrderPaymentStatus {
  AWAITING_PAYMENT = '0',
  AUTHORIZED = '1',
  PAID = '2',
  AUTHORIZATION_FAILED = '3',
  CAPTURE_FAILED = '4',
}

export interface OrderItem {
  id: number;
  item: Product;
  quantity: number;
  day: WeekDay;
  weeklyMenuId: number;
  delivered: boolean;
  deliveredAt: number;
  refundRequested: boolean;
  refundRequestComment: string;
  deliveryConfirmed: boolean;
  deliveryDate: string; //'2024-12-20T00:00:00+00:00';
  prices: ProductPrice;
}

export interface CreateOrderReq {
  type: OrderType;
  items: {
    itemId: number;
    quantity: number;
    day: WeekDay | null;
    weeklyMenuId: number | null;
  }[];
  paymentType: PaymentMethod;
  locationHash: string;
}

export interface OrderConfirmReq {
  barcode: number;
}

export interface DeliveryForDate {
  id: number;
  quantity: number;
  day: string;
  item: Product;
  delivered: boolean;
  // deliveredAt: string;
  refundRequested: boolean;
  refundRequestComment: string;
  deliveryDate: string;
  barcode: number;
  deliveryConfirmed: boolean;
  deliveryConfirmedAt: string;
  weeklyMenuId: number;
}
